import { useState, useEffect } from 'react'
import './style.css'
/*---components---*/
import Navbar from './../components/Navbar'
import MainHeading from './../components/MainHeading'
import  Footer from '../components/Footer';
import Joblist from './Joblist'

/* icons */
import iconSearch from './../images/icon-search.png'
import { getAllJobs } from './../../../api'
import whatsapp from './../images/whatsapp.svg'


function Jobs(){
  const [jobs, setJobs] = useState([])

  const [currentPage, setCurrentPage] = useState(1)
  const [jobPerPage, setJobPerPage] = useState(10)

  const [searchQuery, setSearchQuery] = useState('')
  const [searchJobs, setSearchJobs] = useState([])



  useEffect(async () => {
    const response = await getAllJobs();
    console.log("Res:", response.data.jobs)
    setJobs(response.data.jobs)
  }, [])

  const handlePage = (pgNum) =>{
    console.log(pgNum);
    setCurrentPage(pgNum)
  }

  const pageNumbers = []
  for (let i = 1; i <= Math.ceil(searchJobs.length / jobPerPage); i++) {
     pageNumbers.push(i);
   }

   const renderPageNumbers = pageNumbers.map(num =>{
     return(
       <button className={`jobs__pgnum ${num===currentPage?"jobs__pgnum--current":""}`} key={num} onClick={()=>handlePage(num)}>
         {num}
       </button>
     )
   })

   const indexOfLastJob = currentPage * jobPerPage
   const indexOfFirstJob = indexOfLastJob - jobPerPage
   //const currentJob = jobs.slice(indexOfFirstJob, indexOfLastJob)

  useEffect(() => {
    let tempJob = jobs.filter((job) => job.Name.toLowerCase().includes(searchQuery.toLowerCase())) // []
    console.log("Temp:", tempJob)
    setSearchJobs(tempJob)
    setCurrentPage(1)
  }, [searchQuery, jobs])

  const handleSearch = (e) => {
    setSearchQuery(e.target.value)
  }

  //  const renderJobs = currentJob.map((job, index)=>{
  //   return (<div className="joblist__job" key={index}>
  //             <h2 className="job__name">{job.name}</h2>
  //             <h3 className="job__company">{job.company_name}</h3>
  //             <div  className="job__description">
  //               <p>Jobs Description and Detail</p>
  //               <p>{job.description}</p>
  //             </div>
  //             <div  className="job__footer">
  //               <button className="job__button">Apply</button>
  //             </div>
  //           </div>
  //         )
  // })

  return (
    <>
      <Navbar />
      <main className="jobs__page">
        <a className="whatsapp" href="//api.whatsapp.com/send?phone=+919871013411"><img src={whatsapp} alt="send a message" /></a>
        <MainHeading heading="Jobs" />
        <section className="jobs__search__section">
          <div className="jobs__search__container">
            <input className="jobs__search__input" onChange={handleSearch} value={searchQuery} type="text" placeholder="Search Jobs" />
            <button className="jobs__search__button"><img src={iconSearch} alt="search" /></button>
          </div>
        </section>
        <section>
          <p className="jobs__detail">Showing {searchJobs ? searchJobs.slice(indexOfFirstJob, indexOfLastJob).length : jobs.length} Jobs of total {jobs.length} Vacancies</p>
          <div className="jobs__pgnum__container">
            {renderPageNumbers}
          </div>
          <div className="jobs__joblist__container">
            {searchJobs.slice(indexOfFirstJob, indexOfLastJob).map((job, index) => {
              return (
                <Joblist key={index} job={job}/>
              )
            })
            }
            {/* {!searchQuery ? jobs.map((job, index) => {
              return (<div className="joblist__job" key={index}>
                <h2 className="job__name">{job.name}</h2>
                <h3 className="job__company">{job.company_name}</h3>
                <div className="job__description">
                  <p>Jobs Description and Detail</p>
                  <p>{job.description}</p>
                </div>
                <div className="job__footer">
                  <button className="job__button">Apply</button>
                </div>
              </div>
              )
            }) : searchJobs.map((job, index) => {
              return (<div className="joblist__job" key={index}>
                <h2 className="job__name">{job.name}</h2>
                <h3 className="job__company">{job.company_name}</h3>
                <div className="job__description">
                  <p>Jobs Description and Detail</p>
                  <p>{job.description}</p>
                </div>
                <div className="job__footer">
                  <button className="job__button">Apply</button>
                </div>
              </div>
              )
            })
            } */}
          </div>
        </section>
      </main>
      <Footer />
    </>
  )
}

export default Jobs
